import classnames from 'classnames'
import ExcmalationMark from '../../../components/svg/excmalation-mark'

export default function StatusText({ children, ...rest }) {
  return (
    <div {...rest} className={classnames('auctionStatusText flex alignCenter', rest.className)}>
      <ExcmalationMark width='25' height='25' />
      <div className='children'>{children}</div>

      <style jsx>{`
        .auctionStatusText {
          min-height: 5.1rem;
          padding: 0.5rem 3rem 0.5rem 1.5rem;
          border-radius: 1rem;
          background: #1a1e21;

          :global(svg) {
            min-width: 2.5rem;
          }

          .children {
            margin: 0 0 0 1rem;
            font-size: 1.4rem;
            font-weight: 700;
          }
        }
      `}</style>
    </div>
  )
}
